export default __webpack_public_path__ + "static/media/Vissco Rehabilitation Aids Private Limited .973e8758.jpg";